<!--  -->
<template>
    <div class='card_wrapper box box_v' ref="right1">
        <div class="title">红色物业</div>
         <div class="tr box">
            <div class="td2 ">序号</div>
            <div class="td1 box_f1">街/乡</div>
            <div class="td2">红色物业</div>
            <div class="td2">小区</div>
            <div class="td2" style="margin-right:20px;width:90px">红色物业占比</div>
        </div>
        <div class="scrollContent" :style="{'height':height}" >
            <div class="tr_item box_f1 box" v-for="(item,index) in list" :key="item.communityId">
                <div class="td2 color_white">{{index+1}}</div>
                <div class="td1 box_f1 color_orange">{{item.communityName}}</div>
                <div class="td2 ">{{item.propertyCommitteeCount}}</div>
                <div class="td2 ">{{item.zoneCount}}</div>
                <div class="td2 "  style="margin-right:12px;width:90px">{{(item.propertyCommitteeScale)}}%</div>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            height:'100%',
            contentheight:'100%',
            list:[]
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.xf_wy).then(res=>{
               this.list = res.rows.map(item=>{
                   return{
                       ...item,
                       propertyCommitteeScale:Math.ceil(item.propertyCommitteeScale*100)
                   }
               })
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(()=>{
            this.height = this.$refs.right1.offsetHeight-115 + 'px'
            this.getData()
        })
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.card_wrapper{
    width: 100%;
    height:100%;
    background-image: url('../../../assets/images/monitorctxf/righttop.png');
    background-size: 100% 100%;
    //overflow-y: scroll;
    .title{
        margin:20px 0 20px 20px;
        color:#fff;
        font-size: 18px;
        font-weight: bold
    }
   .tr{
    color:#FFEE9D;
    margin:0 10px 10px 10px;
    height: 38px;
    line-height:38px;
background: linear-gradient(90deg, rgba(67, 96, 71, 0) 0%, rgba(255, 201, 148, 0.5) 48%, rgba(67, 96, 71, 0) 100%);
}
.td1{
    text-align: center;
}
.td2{
    width:60px;
    text-align: center;
}
.td3{
    width:60px;
    text-align: center;
}
.td4{
    width:60px;
}
.scrollContent{
    overflow-y: scroll;
    position: relative;
}
.scrollContent::-webkit-scrollbar {
        width:8px;
        background-color: #470000;
        border-radius:8px;
    }

    /* 滚动槽 */
.scrollContent::-webkit-scrollbar-track {
    border-radius:6px;
    }

    /* 滚动条滑块 */
.scrollContent::-webkit-scrollbar-thumb {
    border-radius:6px;
    background:#ffa800;
}
.tr_item{
    line-height: 36px;
    margin:0 10px;
    .td1{
        color:#fff;
    }
    .td2{
        font-size: 14px;
        font-style: italic;
        color: #0EFCFF;
    }
    .color_orange{
        
        font-weight: bold;
        background: linear-gradient(180deg, #F5A418 0%, #EA7A24 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .color_white{
        color:#fff;
        font-size: 10px;
        font-style: normal
    }
}
}
</style>